import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useFacebookAuthCodeHandler = ({
  siteId,
  facebookAdsTokenHandler,
  facebookAdsAuthenticationStatusRefetch
}: {
  siteId: string;
  facebookAdsTokenHandler: Function;
  facebookAdsAuthenticationStatusRefetch: () => Promise<any>;
}) => {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const authCodeProcessedRef = useRef(false);
  const authCode = searchParams.get('code');
  const stateFromUrl = searchParams.get('state');
  const expectedState = sessionStorage.getItem('fb_oauth_state');

  useEffect(() => {
    if (
      authCode &&
      !authCodeProcessedRef.current &&
      stateFromUrl === expectedState
    ) {
      authCodeProcessedRef.current = true;

      const authenticateWithFacebook = async () => {
        try {
          setIsAuthenticating(true);

          await facebookAdsTokenHandler({
            siteId,
            authenticationCode: authCode
          }).unwrap();

          await facebookAdsAuthenticationStatusRefetch();

          searchParams.delete('code');
          searchParams.delete('state');
          searchParams.delete('scope');
          setSearchParams(searchParams);
        } catch (error) {
          console.error('Failed to authenticate with Facebook Ads:', error);
        } finally {
          setIsAuthenticating(false);
        }
      };

      void authenticateWithFacebook();
    } else if (authCode && stateFromUrl !== expectedState) {
      console.warn('Facebook OAuth state mismatch. Ignoring response.');
    }
  }, [
    authCode,
    stateFromUrl,
    expectedState,
    siteId,
    facebookAdsTokenHandler,
    facebookAdsAuthenticationStatusRefetch,
    searchParams,
    setSearchParams
  ]);

  return { isAuthenticating };
};
